import React from 'react';
import { Switch } from '@material-ui/core';

const IvaSwitch = ({ checked, onChange }) => (
    <Switch
        checked={Boolean(checked)}
        onChange={onChange}
        color="primary"
        size="small"
        disableRipple
    />
);

export default IvaSwitch;
